import React, { FC, ReactElement, useContext, useMemo, useRef } from 'react';
import { SingleDateHeaderProps } from './singleDateHeader.types';
import { StyledDatesHeaderDiv, StyledDateBoxDiv } from './datesHeader.styles';
import moment from 'moment';
import { ContentContext } from '../../index.contexts';
import { usePageContext } from '../../../../../../context/PageContext';
import { getDateText } from './utils';

const SingleDateHeader: FC<SingleDateHeaderProps> = ({
  checkInDate,
  onClearCheckIn,
  focusedCheckIn,
  onClickCheckIn,
  yearSelected,
  monthSelected,
  showIcon,
}) => {
  const { flexibleDates, flexibleDateFormatLabel } = useContext(ContentContext);

  const { currentLocale } = usePageContext();

  /**
   * Return react element to display check in/out date and clear button
   * @param label
   * @param date
   * @param onClearHandler
   * @param onClickHandler
   * @param focused
   */
  const DateBox = (
    label: string,
    date: string,
    onClearHandler: () => void,
    onClickHandler: () => void,
    focused: boolean
  ): ReactElement => {
    const { clear, selectAMonth } = useContext(ContentContext);
    const mainBtn = useRef<HTMLButtonElement>(null);
    const clickTrackingLoc = 'Search Form';

    // handler for clear button click
    const clearClickHandler = (): void => {
      setTimeout(onClearHandler, 0);
      if (window.navigator?.platform?.indexOf('Win') > -1) {
        mainBtn.current?.setAttribute('aria-live', 'polite');
      }
      mainBtn.current?.focus();
    };

    const dateText = useMemo(
      () => getDateText(monthSelected, yearSelected, currentLocale, selectAMonth, flexibleDateFormatLabel),
      [monthSelected, yearSelected, currentLocale, selectAMonth]
    );

    //TODO:commented for future purpose
    // if (focused) {
    //   mainBtn.current?.focus();
    // }

    return (
      <StyledDateBoxDiv className={focused ? 'shop-button-focus' : ''}>
        <button
          type="button"
          ref={mainBtn}
          aria-expanded={focused}
          aria-live={focused ? 'polite' : 'off'}
          className="custom_click_track"
          {...{ custom_click_track_value: `${clickTrackingLoc}| Flexible Date Picker ${label} button |internal` }}
          onClick={onClickHandler}
        >
          <span className="t-label-xs">{label}</span>
          <span className={`h-r-form-field-txt ${!date ? 'gray-shade' : ''}`}>{dateText}</span>
        </button>
        {focused &&
        monthSelected &&
        (monthSelected.toString() + ' ' + yearSelected?.toString() !==
          (moment().month() + 1).toString() + ' ' + moment().year().toString() ||
          showIcon) ? (
          <button
            type="button"
            className="link-white icon-cancel cancel-button custom_click_track"
            {...{
              custom_click_track_value: `${clickTrackingLoc}| Flexible Date Picker ${label} clear button |internal`,
            }}
            onClick={clearClickHandler}
          >
            <span className="sr-only">{clear}</span>
          </button>
        ) : (
          ''
        )}
      </StyledDateBoxDiv>
    );
  };

  return (
    <StyledDatesHeaderDiv>
      {DateBox(flexibleDates, checkInDate, onClearCheckIn, onClickCheckIn, focusedCheckIn)}
    </StyledDatesHeaderDiv>
  );
};

export default SingleDateHeader;
